import Skeleton from 'antd/lib/skeleton'

import 'antd/lib/skeleton/style'

export * from 'antd/lib/skeleton'

export default Skeleton
